import styles from './BrowseByStateStrip.module.css'

/** Links to the static /rc-races/{slug}/ region pages (Feature 164) - built from the same
 *  regions.json manifest the server-rendered version of this page used (events/index.cfm's
 *  _eventsListGate.cfm include), set on window by that same shell, so this never needs its own
 *  fetch and never links to a region that doesn't actually have a published page (the Node
 *  generator only lists regions it generated a file for - see web/pages/region-pages).
 *
 *  Lives as a footer band at the bottom of the page, not up near the search bar - it's an SEO
 *  internal-link path to the region pages (crawl discovery + link equity), not a feature racers
 *  come to this page to use, so it shouldn't compete with search/filters/results for attention. */
export function BrowseByStateStrip() {
  const regions = window.__RC_RACES_REGIONS__ ?? []
  if (regions.length === 0) return null

  return (
    <footer className={styles.strip}>
      <div className={styles.inner}>
        <span className={styles.label}>Browse races by state</span>
        <nav aria-label="Browse races by state" className={styles.links}>
          {regions.map((r) => (
            <a key={r.slug} href={`/rc-races/${r.slug}/`} className={styles.link}>
              {r.name}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  )
}
